import '@mdxeditor/editor/style.css';
import {
    BlockTypeSelect,
    BoldItalicUnderlineToggles,
    CreateLink,
    headingsPlugin,
    imagePlugin,
    InsertImage,
    linkDialogPlugin,
    listsPlugin,
    ListsToggle,
    markdownShortcutPlugin,
    MDXEditor,
    quotePlugin,
    tablePlugin,
    thematicBreakPlugin,
    toolbarPlugin,
    UndoRedo,
} from '@mdxeditor/editor';
import { useMemo } from 'react';

interface Props {
    markdown: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    className?: string;
    readonly?: boolean;
    onSendMessageEnter?: (value: string) => void;
}

export function MarkDownEditorComponent({ markdown, onChange, placeholder, className, readonly, onSendMessageEnter }: Props) {
    const pluginsMemo = useMemo(() => {
        const p = [
            headingsPlugin(),
            imagePlugin(),
            listsPlugin(),
            quotePlugin(),
            tablePlugin(),
            thematicBreakPlugin(),
            markdownShortcutPlugin(),
            linkDialogPlugin(),
            toolbarPlugin({
                toolbarClassName: 'my-classname',
                toolbarContents: () => (
                    <>
                        <UndoRedo />
                        <BlockTypeSelect />
                        <BoldItalicUnderlineToggles />
                        <CreateLink />
                        <ListsToggle />
                        <InsertImage />
                    </>
                ),
            }),
        ];

        if (readonly) {
            p.pop();
        }

        return p;
    }, [readonly]);

    return (
        <div
            onKeyDown={(e) => {
                if(onSendMessageEnter) {
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        onSendMessageEnter(markdown);
                    }
                }
            }}
        >
            <MDXEditor
                autoFocus
                markdown={markdown}
                className={`mdx-editor-ai ${className ? className : ''} ${!readonly ? 'no-readonly-mkd' : ''}`}
                onChange={onChange}
                placeholder={placeholder}
                readOnly={readonly}
                plugins={pluginsMemo}
            />
        </div>
    );
}
